var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-carousel',{class:[_vm.isFullWidth ? 'carousel--full-width' : 'carousel--contained', { 'carousel--light': _vm.isLight }],style:(`
  --icon-next: url('${require('@/assets/icons/icon-next.svg')}'); 
  --icon-prev: url('${require('@/assets/icons/icon-prev.svg')}');
  --icon-next-light: url('${require('@/assets/icons/icon-next-light.svg')}'); 
  --icon-prev-light: url('${require('@/assets/icons/icon-prev-light.svg')}'); 
  --icon-next-circle: url('${require('@/assets/icons/icon-next-circle.svg')}'); 
  --icon-prev-circle: url('${require('@/assets/icons/icon-prev-circle.svg')}');`),attrs:{"controls":"","indicators":"","interval":0}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }